import { render, staticRenderFns } from "./ViewIncidentPopup.vue?vue&type=template&id=ef55abb4&"
import script from "./ViewIncidentPopup.vue?vue&type=script&lang=js&"
export * from "./ViewIncidentPopup.vue?vue&type=script&lang=js&"
import style0 from "./ViewIncidentPopup.vue?vue&type=style&index=0&id=ef55abb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports